import {Dialog, DialogContent, DialogFooter, DialogHeader} from '@/shadcn_components/ui/dialog';
import {TransformWrapper, TransformComponent} from 'react-zoom-pan-pinch';
import React from 'react';
import {MagnifyingGlassMinusIcon, MagnifyingGlassPlusIcon} from '@heroicons/react/24/solid';
import {ViewfinderCircleIcon, XMarkIcon} from '@heroicons/react/24/outline';
import {Button} from '@/shadcn_components/ui/button';

const MediaViewPopup = ({open, onClose, title, src, ...props}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="h-screen min-w-full bg-black bg-opacity-0 p-0">
        <TransformWrapper
          // centerOnInit={true}
          centerZoomedOut={true}
          // initialScale={1}
          // initialPositionX={200}
          limitToBounds={true}
          minScale={0.1}
          maxScale={10}
          {...props}>
          {({zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest}) => (
            <React.Fragment>
              <div className="fixed bg-white opacity-100 left-0 top-0 right-0 z-[1400] flex flex-row gap-1 justify-center items-center">
                <p className="pl-1">{title}</p>
                <Button size="icon" variant="ghost" onClick={() => zoomIn()}>
                  <MagnifyingGlassPlusIcon className="w-6 h-6" />
                </Button>
                <Button size="icon" variant="ghost" onClick={() => zoomOut()}>
                  <MagnifyingGlassMinusIcon className="w-6 h-6" />
                </Button>
                <Button
                  size="icon"
                  variant="ghost"
                  onClick={() => {
                    // centerView();
                    zoomToElement('view_image', undefined, 200);
                  }}>
                  <ViewfinderCircleIcon className="w-6 h-6" />
                </Button>
                <Button size="icon" variant="ghost" onClick={() => onClose()}>
                  <XMarkIcon className="w-6 h-6" />
                </Button>
              </div>
              <TransformComponent
                wrapperStyle={{
                  // position: 'fixed',
                  // left: 0,
                  // right: 0,
                  // top: 0,
                  height: '100vh',
                  width: '100vw',
                }}
                {...props}>
                <img
                  id="view_image"
                  src={src}
                  alt=""
                  style={{width: '100%'}}
                  onLoad={() => {
                    zoomToElement('view_image', undefined, 200);
                  }}
                />
              </TransformComponent>
            </React.Fragment>
          )}
        </TransformWrapper>
      </DialogContent>
    </Dialog>
  );
};

export default MediaViewPopup;
